import React, { useState } from "react";
import ICPTOS from "../../../assets/documents/Terms_of_Service.pdf";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import request from "src/utils/request";
import { useDispatch } from "react-redux";
import { toastify } from "src/utils/toast";
import { Document, Page } from "react-pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import { setModalState } from "src/redux/actions/modalActions";
import { loadingBtnAction } from "src/redux/actions/userActions";
import {
  Box,
  Button,
  CardActions,
  Chip,
  Divider,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  alpha,
  useTheme,
} from "@mui/material";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;

const TermsOfService = ({ email }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [numPages, setNumPages] = useState();
  const [inputEmail, setEmail] = useState("");
  const isMobile = useMediaQuery("(max-width:600px)");

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleAccept = async () => {
    const payload = { email: email === "" ? inputEmail : email };

    dispatch(loadingBtnAction(true));
    try {
      const res = await request.post("/tos/accept", payload);

      if (res) {
        dispatch(loadingBtnAction(false));
        dispatch(setModalState(undefined));
        toastify("success", res.data.message);
      }
    } catch (e) {
      toastify("error", e.message);
      dispatch(loadingBtnAction(false));
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: { xs: "100%", md: 880 },
        mx: "auto",
        height: {
          xs: "calc(100dvh - 32px)",
          sm: "calc(100dvh - 80px)",
          md: "calc(100dvh - 96px)",
        },
        maxHeight: {
          xs: "calc(100dvh - 32px)",
          sm: "calc(100dvh - 80px)",
          md: "calc(100dvh - 160px)",
        },
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          mb: 1.5,
          flexShrink: 0,
        }}
      >
        <Typography
          variant={isMobile ? "h5" : "h4"}
          sx={{ fontWeight: 700, letterSpacing: "-0.01em" }}
          gutterBottom
        >
          Terms of Service
        </Typography>
        <Chip
          label="Last updated February 25, 2025"
          size="small"
          sx={{
            bgcolor: alpha(theme.palette.secondary.main, 0.08),
            color: theme.palette.primary.dark,
            fontWeight: 600,
            borderRadius: "999px",
          }}
        />
      </Box>

      <Paper
        elevation={0}
        sx={{
          flex: 1,
          minHeight: 0,
          borderRadius: 3,
          border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
          background: `linear-gradient(180deg, ${alpha(
            theme.palette.background.paper,
            1
          )} 0%, ${alpha(theme.palette.secondary.main, 0.015)} 100%)`,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            height: "100%",
            overflowY: "auto",
            px: isMobile ? 1 : 2,
            py: isMobile ? 1.25 : 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Document file={ICPTOS} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.apply(null, Array(numPages))
              .map((x, i) => i + 1)
              .map((page) => {
                return (
                  <Box key={page} sx={{ mb: 2, "&:last-of-type": { mb: 0 } }}>
                    <Page
                      pageNumber={page}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                      scale={isMobile ? 0.7 : 0.9}
                    />
                  </Box>
                );
              })}
          </Document>
        </Box>
      </Paper>

      {email === "" && (
        <TextField
          type="email"
          label="Your email"
          placeholder="you@company.com"
          fullWidth
          onChange={(e) => setEmail(e.target.value)}
          required
          sx={{
            mt: 1.5,
            flexShrink: 0,
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
            },
          }}
        />
      )}

      <Divider sx={{ my: 1.5, flexShrink: 0 }} />

      <CardActions
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: isMobile ? "column-reverse" : "row",
          gap: 1.25,
          px: 0,
          py: 0.5,
          flexShrink: 0,
        }}
      >
        <Button
          variant="text"
          color="inherit"
          fullWidth={isMobile}
          onClick={() => dispatch(setModalState(undefined))}
          sx={{
            color: "text.secondary",
            fontWeight: 600,
            minWidth: 110,
          }}
        >
          Decline
        </Button>
        <Button
          variant="contained"
          color="primary"
          fullWidth={isMobile}
          disabled={email === "" && inputEmail === ""}
          onClick={handleAccept}
          sx={{
            minWidth: 140,
            px: 2.5,
            py: 1.1,
            borderRadius: 2,
            fontWeight: 700,
            boxShadow: `0 10px 24px ${alpha(theme.palette.secondary.main, 0.32)}`,
            "&:hover": {
              boxShadow: `0 14px 28px ${alpha(
                theme.palette.secondary.main,
                0.42
              )}`,
            },
          }}
        >
          Accept & Continue
        </Button>
      </CardActions>
    </Box>
  );
};

export default TermsOfService;
